// extracted by mini-css-extract-plugin
export var button = "BackToTopBtn-module--button--12d77";
export var cdsAssistiveText = "BackToTopBtn-module--cds--assistive-text--289f9";
export var cdsVisuallyHidden = "BackToTopBtn-module--cds--visually-hidden--3bac4";
export var hideFeedback = "BackToTopBtn-module--hide-feedback--9690c";
export var showFeedback = "BackToTopBtn-module--show-feedback--659fe";
export var skeleton = "BackToTopBtn-module--skeleton--0fd29";